// composables/useLoading.js
import { ref } from 'vue';

const isLoading = ref(false);
const loadingMessage = ref("מטעין...");

export function useLoading() {
  function startLoading(message = "מטעין...") {
    isLoading.value = true;
    loadingMessage.value = message;
  }

  function stopLoading() {
    isLoading.value = false;
    loadingMessage.value = "מטעין...";
  }

  return { isLoading, loadingMessage, startLoading, stopLoading };
}
